<template>
  <!-- Tudo o que não é deste componente passa direto ao campo do Vuetify: modelo, rótulo,
       múltiplo, mensagens. Como o CreatableAutocomplete. -->
  <component :is="field" v-bind="$attrs" :items="people" :item-title="free ? 'email' : 'name'"
             :item-value="free ? 'email' : 'user'" :return-object="false"
             :filter-keys="['title', 'raw.name']" auto-select-first>
    <!-- O e-mail aparece onde a pessoa vem com ele: no convite, que é de quem administra. No modo de
         uso ele nem chega (decisão do usuário), e o que distingue dois homônimos é o id. -->
    <template #item="{item, props}">
      <v-list-item v-bind="props" :title="undefined">
        <ontos-person-line :user="item.user" :email="item.email" :name="item.name" :photo="item.photo"/>
      </v-list-item>
    </template>
    <!-- O escolhido aparece numa linha só, para caber no campo. O texto livre do convite chega como
         texto, e não como pessoa: é um e-mail que não está na lista. -->
    <template #selection="{item}">
      <ontos-person-line v-if="typeof item === 'object'" class="person-select-chosen" dense
                         :user="item.user" :email="item.email" :name="item.name" :photo="item.photo"/>
      <span v-else>{{ item }}</span>
    </template>
  </component>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import {VAutocomplete, VCombobox} from 'vuetify/components'
import PersonLine from '@/components/shared/PersonLine.vue'
import {Person, WorkspacePerson} from '@/types/Person'

/**
 * Escolher pessoas: cada uma com a cara e o nome, achada pelo nome — e pelo e-mail no convite. Um
 * componente para os três lugares que escolhem gente — o convite de ambiente, o campo de usuário
 * do item e o filtro dessa coluna na listagem —, que antes de existir eram slots escritos à mão.
 *
 * **`free`** é o convite: `v-combobox`, que aceita qualquer texto, com o valor sendo o E-MAIL — é
 * por ele que se convida quem ainda não está no lunedi. Sem `free`, `v-autocomplete`, com o valor
 * sendo o ID da conta (`user`), que é o que o item guarda: só se escolhe quem está na lista.
 *
 * `auto-select-first`: o primeiro que casa fica marcado, e Enter ou Tab o escolhe sem o mouse
 * (pedido do usuário).
 */
@Component({
  name: 'ontos-person-select',
  inheritAttrs: false,
  components: {'ontos-person-line': PersonLine}
})
class PersonSelect extends Vue {
  @Prop({type: Array, default: () => []}) readonly people!: Array<Person | WorkspacePerson>
  @Prop({type: Boolean, default: false}) readonly free!: boolean

  get field() {
    return this.free ? VCombobox : VAutocomplete
  }
}

export default toNative(PersonSelect)
</script>

<style scoped>
/* No múltiplo, uma pessoa por linha dentro do campo, com um respiro entre elas */
.person-select-chosen {
  margin: 2px 0;
  width: 100%;
}
</style>
